'use strict';

var symbols = require('./constants').symbols;

module.exports = function getCurrencySymbol(currencyENUM) {
    return symbols[currencyENUM];
};



//////////////////
// WEBPACK FOOTER
// ./~/dibs-currency-helpers/getCurrencySymbol.js
// module id = 2079
// module chunks = 63